import { Module } from 'vuex';
import { RootState, Testimonial } from 'frontend/types';

interface TestimonialState {
  items: Testimonial[];
}

const premiumTestimonials: Module<TestimonialState, RootState> = {
  namespaced: true,
  state: {
    items: [] as Testimonial[],
  },
  mutations: {
    setValue(state: TestimonialState, value: Testimonial[]): void {
      state.items = value;
    },
  },
};

export default premiumTestimonials;
